import { EXPORT_TYPE } from '../../../../../lib/constants';
import AddFeatureToCollectionModal from '../../../../Modals/AddFeatureToCollectionModal';
import Button from '../../../../Button';
import Alert from '../../../../Modals/Alert';
import AlertCircle from '../../../../../assets/svg/Feather/AlertCircle';
import Check from '../../../../../assets/svg/Feather/Check';
import CornerRightUp from '../../../../../assets/svg/Feather/CornerRightUp';
import Download from '../../../../../assets/svg/Feather/Download';
import ghAnalytics from '../../../../../lib/analytics';

export default (dispatch) => {
  const addFeatureToCollections = (collections, featureIds) => {
    ghAnalytics.logSelectToCollection(featureIds);
    const collectionIds = collections.map((collection) => collection.uuid);

    dispatch({
      type: 'toast/show',
      payload: {
        text: 'Adding items to hunts...',
        loader: true,
      },
    });

    dispatch({
      type: 'modals/close',
    });

    dispatch({
      type: 'features/addSelectedFeaturesToCollections',
      payload: {
        collectionIds,
        featureIds: featureIds,
      },
      callback: (response) => {
        if (!response) {
          dispatch({
            type: 'toast/show',
            payload: {
              text: 'An error occurred when adding your items to hunts.',
              icon: AlertCircle,
              iconColor: '#ff3b30',
              dismissable: true,
            },
          });
        } else {
          ghAnalytics.logCollectionBulkItemsAdded(collections,featureIds);
          let actionPayload = {}
          for (let fidi = 0; fidi < featureIds.length; fidi++) {
            actionPayload = {
              featureId: featureIds[fidi],
              collectionIds: collectionIds,
            }
            dispatch({
              type: 'features/addFeatureToCollections',
              payload: actionPayload
            });

            dispatch({
              type: 'collections/addFeatureToCollectionsList',
              payload: actionPayload
            });
          }

          dispatch({
            type: 'toast/show',
            payload: {
              text: 'Items added to hunts',
              icon: Check,
              iconColor: '#f37735',
            },
          });
          dispatch({
            type: 'map/resetWidgetState',
          });
          dispatch({
            type: 'features/resetSelectedFeatures'
          });
          setTimeout(() => {
            dispatch({
              type: 'toast/dismiss',
            });
          }, 3500);
        }
      },
    });
  };
  const closeModal = () => {
    dispatch({
      type: 'modals/close',
    });
  };

  const deleteFeatures = (featureIds) => () => {
    const errorText = 'There was an issue and your items were not deleted.'

    ghAnalytics.logSelectToDelete(featureIds);

    closeModal();

    dispatch({
      type: 'toast/show',
      payload: {
        text: 'Deleting content...',
        loader: true,
      },
    });

    dispatch({
      type: 'features/setIsDeletingItems',
      payload: true,
    });

    dispatch({
      type: 'features/deleteSelectedFeatures',
      payload: { featureIds },
      callback: (result) => {
        dispatch({
          type: 'features/setIsDeletingItems',
          payload: false,
        });     
        if (!result) {   
          dispatch({
            type: 'toast/show',
            payload: {
              text: errorText,
              icon: AlertCircle,
              iconColor: '#ff3b30',
              dismissable: true,
            },
          });
        } else {
          dispatch({
            type: 'toast/show',
            payload: {
              text: 'Content deleted',
              icon: Check,
              iconColor: '#f37735',
            },
          });
          dispatch({
            type: 'map/resetWidgetState',
          });
          dispatch({
            type: 'features/resetSelectedFeatures'
          });
          setTimeout(() => {
            dispatch({
              type: 'toast/dismiss',
            });
          }, 3500);
        }
      },
    });
  };

  const exportFeatures = (featureIds, format) => () => {
    closeModal();

    dispatch({
      type: 'toast/show',
      payload: {
        text: 'Exporting your content...',
        loader: true
      }
    });

    dispatch({
      type: 'features/exportFeatures',
      payload: {
        fileType: format,
        featureIds: featureIds
      },
      callback: (exportId) => {
        if (!exportId) {
          dispatch({
            type: 'toast/show',
            payload: {
              text: 'There was an error generating your export.',
              icon: AlertCircle,
              iconColor: '#ff3b30',
              dismissable: true
            }
          });
        } else {
          dispatch({
            type: 'features/getExportPoll-start',
            payload: exportId,
            callback: (exportUrl) => {
              dispatch({
                type: 'features/getExportPoll-stop',
              });

              setTimeout(() => {
                if (exportUrl) {
                  dispatch({
                    type: 'toast/show',
                    payload: {
                      text: 'Preparing to download...',
                      loader: true
                    }
                  });

                  window.open(exportUrl, '_blank');

                  dispatch({
                    type: 'toast/show',
                    payload: {
                      text: 'Click here if download has not started.',
                      icon: Download,
                      dismissable: true,
                      onClick: (e) => {
                        window.open(exportUrl, '_blank');

                        dispatch({
                          type: 'toast/dismiss'
                        });
                      }
                    }
                  });
                } else {
                  dispatch({
                    type: 'toast/show',
                    payload: {
                      text: 'There was an error fetching your export.',
                      icon: AlertCircle,
                      iconColor: '#ff3b30',
                      dismissable: true
                    }
                  });
                }
              }, 3500);
            }
          });
        }
      }
    });
  };

  return {
    cancelAction: (featureIds) => {
      ghAnalytics.logSelectToCancel(featureIds);
      dispatch({
        type: 'map/resetWidgetState',
      });
      dispatch({
        type: 'features/setIsCanceling',
        payload: true
      });
      dispatch({
        type: 'features/resetSelectedFeatures',
        callback: () => {
          setTimeout(() => {
            dispatch({
              type: 'features/setIsCanceling',
              payload: false
            });
          }, 50)
        }
      });
    },
    showAddToCollectionModal: (featureIds) => {
      dispatch({
        type: 'modals/add',
        payload: {
          component: AddFeatureToCollectionModal,
          props: {
            selectedFeatures: featureIds,
            onAdd: addFeatureToCollections,
            onClose: () => {
              dispatch({ type: 'modals/close' });
            },
          },
        },
      });
    },
    showDeleteModal: (featureIds) => {
      dispatch({
        type: 'modals/add',
        payload: {
          component: Alert,
          props: {
            title: 'Delete Items?',
            subtitle: 'Are you sure you want to delete these items? You will lose all notes and photos associated with them.',
            actionItems: [
              {
                title: 'Delete',
                onClick: deleteFeatures(featureIds),
              },
              {
                title: 'Cancel',
                theme: Button.THEME.solidSecondary,
                onClick: () => {
                  dispatch({
                    type: 'modals/close',
                  });
                },
              },
            ],
          },
        },
      });
    },
    showExportModal: (featureIds) => {
      dispatch({
        type: 'modals/add',
        payload: {
          component: Alert,
          props: {
            icon: CornerRightUp,
            title: 'Export map items',
            subtitle: 'Choose the file format for your export',
            actionItems: [
              {
                title: 'GPX (.gpx)',
                onClick: exportFeatures(featureIds, EXPORT_TYPE.GPX),
              },
              {
                title: 'KML (.kml)',
                onClick: exportFeatures(featureIds, EXPORT_TYPE.KML),
              },
              {
                title: 'Cancel',
                theme: Button.THEME.solidSecondary,
                onClick: () => {
                  dispatch({
                    type: 'modals/close',
                  });
                },
              },
            ],
          },
        },
      });
    },
    toggleEditStyles: () => {
      dispatch({ type: 'features/toggleEditingFeature' });
    }
  };
};
